<template>
  <el-dialog 
    :title="mode === 'add' ? '新增质保项目' : '编辑质保项目'"
    :visible="visible"
    :close-on-click-modal="false"
    :modal="false"
    @close="closeDialog()"
    width="800px"
    center
  >
    <el-form 
      :model="form" 
      :rules="rules"
      ref="warrantyItemForm"
      label-width="120px"
    >
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="form.projectName" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      
      <el-form-item label="项目地址" prop="projectAddress">
        <el-input v-model="form.projectAddress" placeholder="请输入项目地址"></el-input>
      </el-form-item>
      <el-form-item label="质保门店" prop="storeName">
        <el-select 
          v-model="form.storeName" 
          placeholder="请选择质保门店"
          filterable
          clearable
          @change="handleStoreChange"
          style="width: 100%"
        >
          <el-option
            v-for="store in storeOptions"
            :key="store.id"
            :label="store.name"
            :value="store.name"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="门店地址" prop="storeAddress">
        <el-input 
          v-model="form.storeAddress" 
          placeholder="请先选择质保门店"
          :disabled="true"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="质保内容" prop="warranties">
        <div v-for="(item, index) in form.warranties" :key="index" class="warranty-form-item">
          <div class="warranty-form-header">
            <span>质保内容 #{{ index + 1 }}</span>
            <el-button 
              type="danger" 
              icon="el-icon-delete" 
              size="mini" 
              circle 
              @click="removeWarrantyItem(index)"
              v-if="form.warranties.length > 1"
            ></el-button>
          </div>
          <el-form-item 
            :prop="`warranties.${index}.content`" 
            :rules="{ required: true, message: '请输入质保内容', trigger: 'blur' }"
          >
            <el-input 
              v-model="item.content" 
              placeholder="质保内容描述" 
              style="margin-bottom: 10px;"
            ></el-input>
          </el-form-item>
          <div class="date-range-container">
            <el-form-item 
              :prop="`warranties.${index}.starTime`" 
              :rules="{ required: true, message: '请选择开始日期', trigger: 'change' }"
              class="date-range-item"
            >
              <el-date-picker
                v-model="item.starTime"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
                :picker-options="startDateOptions(index)"
                style="width: 100%;"
                @change="validateDateRange(index)"
              ></el-date-picker>
            </el-form-item>

            <span class="date-range-separator">至</span>

            <el-form-item 
              :prop="`warranties.${index}.endTime`" 
              :rules="{ required: true, message: '请选择结束日期', trigger: 'change' }"
              class="date-range-item"
            >
              <el-date-picker
                v-model="item.endTime"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="endDateOptions(index)"
                style="width: 100%;"
                @change="validateDateRange(index)"
              ></el-date-picker>
            </el-form-item>
          </div>
        </div>
        
        <el-button 
          type="primary" 
          icon="el-icon-plus" 
          @click="addWarrantyItem"
          size="small"
        >
          添加质保内容
        </el-button>
      </el-form-item>
      
      <el-form-item label="效果图">
        <el-upload
          action=""
          :auto-upload="false"
          :on-change="handleEffectImageChange"
          :show-file-list="false"
          accept="image/*"
          :multiple="true"
        >
          <el-button size="small" type="primary">上传图片</el-button>
          <div slot="tip" class="el-upload__tip">支持 JPG、PNG 格式，每张大小不超过5MB，最多3张</div>
        </el-upload>
        
        <div v-if="form.effectImages.length > 0" class="images-preview">
          <div v-for="(image, index) in form.effectImages" :key="index" class="image-preview-item">
            <el-image 
              style="width: 120px; height: 90px;"
              :src="image.url" 
              fit="cover"
              :preview-src-list="form.effectImages.map(img => img.url)"
            ></el-image>
            <div class="image-actions">
              <el-button 
                type="danger" 
                icon="el-icon-delete" 
                size="mini" 
                circle
                @click="removeEffectImage(index)"
              ></el-button>
            </div>
          </div>
        </div>
      </el-form-item>
      
      <el-form-item label="合同文件">
        <el-upload
          action=""
          :auto-upload="false"
          :on-change="handleContractFileChange"
          :show-file-list="false"
          accept=".pdf,.doc,.docx"
        >
          <el-button size="small" type="primary">上传合同</el-button>
          <div slot="tip" class="el-upload__tip">支持 PDF、DOC、DOCX 格式</div>
        </el-upload>
        
        <div v-if="form.contract" class="file-preview">
          <i class="el-icon-document" style="font-size: 36px; color: #409EFF;"></i>
          <div class="file-info">
            <div>{{ getFileName(form.contract) }}</div>
            <el-button 
              type="danger" 
              icon="el-icon-delete" 
              size="mini" 
              @click="form.orginContract = ''; form.contract = ''"
            >删除</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog()">取 消</el-button>
      <el-button type="primary" @click="submitForm">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {getShops} from '../api/admin'

export default {
  name: 'WarrantyItemDialog',
  props: {
    visible: Boolean,
    mode: String, // 'add' 或 'edit'
    form: Object,
  },
  data() {
    return {
      storeOptions: [],
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        projectAddress: [
          { required: true, message: '请输入项目地址', trigger: 'blur' }
        ],
        storeName: [
          { required: true, message: '请选择质保门店', trigger: 'change' }
        ],
        storeAddress: [
          { required: true, message: '请选择质保门店', trigger: 'change' }
        ],
        warranties: [
          { 
            validator: (rule, value, callback) => {
              const validItems = value.filter(item => 
                item.content.trim() && 
                item.starTime && 
                item.endTime
              );
              if (validItems.length === 0) {
                callback(new Error('至少需要填写一个有效的质保内容'));
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          }
        ]
      }
    }
  },
  mounted(){
    this.getAllShops()
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    },

    getAllShops(){
      getShops().then(res =>{
        if(res.code == 1)
        {
          this.storeOptions = []
          res.data.forEach(element => {
              this.storeOptions.push({
                  id:element.ID,
                  name: element.ShopName,
                  address: element.ShopAddress
              })
          });
        }
      })
    },

    startDateOptions(index) {
      return {
        disabledDate: (time) => {
          // 开始日期不能晚于当前结束日期（如果有）
          if (this.form.warranties[index].endTime) {
            return time.getTime() > new Date(this.form.warranties[index].endTime).getTime();
          }
          // 可选日期范围：今天往前10年，往后20年
          const minDate = new Date();
          minDate.setFullYear(minDate.getFullYear() - 10);
          
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 20);
          
          return time.getTime() < minDate.getTime() || 
                time.getTime() > maxDate.getTime();
        }
      };
    },

    handleStoreChange(selectedStoreName) {
      if (!selectedStoreName) {
        this.form.storeAddress = '';
        return;
      }
      
      const selectedStore = this.storeOptions.find(store => store.name === selectedStoreName);
      if (selectedStore) {
        this.form.storeAddress = selectedStore.address;
      } else {
        this.form.storeAddress = '';
      }
      
      // 手动触发验证
      this.$nextTick(() => {
        this.$refs.warrantyItemForm.validateField('storeAddress');
      });
    },

    endDateOptions(index) {
      return {
        disabledDate: (time) => {
          // 结束日期不能早于当前开始日期（如果有）
          if (this.form.warranties[index].starTime) {
            return time.getTime() < new Date(this.form.warranties[index].starTime).getTime();
          }
          // 可选日期范围：今天往前10年，往后20年
          const minDate = new Date();
          minDate.setFullYear(minDate.getFullYear() - 10);
          
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 20);
          
          return time.getTime() < minDate.getTime() || 
                time.getTime() > maxDate.getTime();
        }
      };
    },

    // 验证日期范围
    validateDateRange(index) {
      const warranty = this.form.warranties[index];
      if (warranty.starTime && warranty.endTime) {
        const start = new Date(warranty.starTime);
        const end = new Date(warranty.endTime);
        if (start > end) {
          this.$message.error('结束日期不能早于开始日期');
          // 自动纠正错误的日期
          if (this.$refs.warrantyItemForm) {
            this.$refs.warrantyItemForm.validateField(`warranties.${index}.starTime`);
            this.$refs.warrantyItemForm.validateField(`warranties.${index}.endTime`);
          }
        }
      }
    },
    
    // 添加新的质保内容项
    addWarrantyItem() {
      this.form.warranties.push({
        content: '',
        starTime: '',
        endTime: ''
      });
    },
    
    // 移除质保内容项
    removeWarrantyItem(index) {
      this.form.warranties.splice(index, 1);
    },
    
    // 处理效果图上传
    handleEffectImageChange(file) {
      if (this.form.effectImages.length >= 3) {
        this.$message.warning('最多只能上传3张图片');
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.effectImages.push({
          url: e.target.result,
          file: file.raw,
          originUrl: ''
        });
      };
      reader.readAsDataURL(file.raw);
    },
    
    removeEffectImage(index) {
      this.form.effectImages.splice(index, 1);
    },
    
    // 处理合同文件上传
    handleContractFileChange(file) {
      this.form.contract = file.name;
      this.$message.info(`已选择合同文件: ${file.name}`);
      this.form.contractFile = file.raw; // 保存文件对象
    },
    
    // 获取文件名
    getFileName(path) {
      if (!path) return '';
      return path.split('/').pop();
    },
    
    submitForm() {
      this.$refs.warrantyItemForm.validate(valid => {
        if (valid) {
          // 验证所有质保内容的日期范围
          const hasInvalidDate = this.form.warranties.some(item => {
            if (!item.starTime || !item.endTime) return true;
            
            const startDate = new Date(item.starTime);
            const endDate = new Date(item.endTime);
            
            return startDate > endDate;
          });
          
          if (hasInvalidDate) {
            this.$message.error('结束日期不能早于开始日期');
            return;
          }

          this.$emit('submit');
          this.closeDialog();
        }
      });
    }
  }
}
</script>

<style scoped>
.warranty-form-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
}

.warranty-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.date-range-container {
  display: flex;
  align-items: center;
}

.date-range-item {
  flex: 1;
  margin-bottom: 0 !important;
}

.date-range-separator {
  padding: 0 8px;
  color: #606266;
}

.images-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.image-preview-item {
  position: relative;
}

.image-actions {
  position: absolute;
  top: -10px;
  right: -10px;
}

.file-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.file-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.dialog-footer {
  text-align: center;
}
</style>